import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { environment } from "src/environments/environment";

@Injectable({
  providedIn: "root",
})
export class EnterpriseService {
  constructor(private http: HttpClient) {}

  getSubscriptionPlans(planType: Number) {
    return this.http.get(
      environment.apiUrl + `enterprise/plans?planType=${planType}`,
    );
  }
  addSubscriptionPlan(data: any) {
    return this.http.post(environment.apiUrl + "enterprise/plan/add", data);
  }

  updateSubscriptionPlan(data: any, id: "") {
    return this.http.put(
      environment.apiUrl + `enterprise/plan/update/${id}`,
      data,
    );
  }
  deleteSubscriptionPlan(id: "") {
    return this.http.delete(
      environment.apiUrl + `enterprise/plan/delete/${id}`,
    );
  }

  getEnterpriseRequests(data: any) {
    return this.http.post(environment.apiUrl + "enterprise/requests", data);
  }

   getEnterpriseRequestdetails(id: any) {
    return this.http.get(environment.apiUrl + `enterprise/request-by-id/${id}`);
  }
  getEnterprisedetails(id: any) {
    return this.http.get(environment.apiUrl + `admin/enterprise/${id}`);
  }
  getEnterpriseDocuments(id: "") {
    return this.http.get(
      environment.apiUrl + `admin/enterprise/document/details/${id}`,
    );
  }
  updateRequest(id: "", data: any) {
    return this.http.put(environment.apiUrl + `enterprise/approve/${id}`, data);
  }

  getEntpEmployeeRequests(data: any) {
    return this.http.post(
      environment.apiUrl + "enterprise/employee/requests",
      data,
    );
  }
  approveRejectEntpEmployeeRequest(id: "", data: any) {
    return this.http.put(
      environment.apiUrl + `enterprise/employee/approve/${id}`,
      data,
    );
  }

  getEntpBranchRequests(data: any) {
    return this.http.post(
      environment.apiUrl + "enterprise/branch/requests",
      data,
    );
  }
  approveRejectEntpBranchRequest(id: "", data: any) {
    return this.http.put(
      environment.apiUrl + `enterprise/branch/approve/${id}`,
      data,
    );
  }

  getTrips(data: any) {
    return this.http.post(environment.apiUrl + "admin/enterprise/trips", data);
  }
  getTripByID(id: string) {
    return this.http.get(
      environment.apiUrl + `admin/enterprise/trip/details/${id}`,
    );
  }
  
  getLastTripsCount(data: any) {
    return this.http.post(environment.apiUrl + "admin/enterprise/trips-count", data);
  }

  getEnterpriseList(params: any) {
    return this.http.get(environment.apiUrl + "admin/enterprise/list", {
      params,
    });
  }
  getEnterpriseByID(id: string) {
    return this.http.get(environment.apiUrl + `admin/enterprise/${id}`);
  }
}
